const drawer = new window.theme.CartDrawer();

function add_to_cart(id, selling) {

    let formData = { quantity: 1, id: id, selling_plan: selling };

    fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            return response.json();
        })
        .then(data => {
            //let closeTrigger = modal.querySelector(".close-modal");
            //closeTrigger.click();

            setTimeout(function() {
                drawer.open();
                drawer.init();
            }, 500);
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}
let variant_price, price;
//product modal PLP
function open_Modal(modal, sellingActive) {
    document.body.append(modal);
    modal.classList.add("active");
    document.querySelector("html").classList.add("modal-inicialized");
}

function close_Modal(sectionModal, modal) {
    sectionModal.append(modal);
    let variants = modal.querySelectorAll(".variant-product");
    variants.forEach(function(variant) {
        variant.classList.remove("selected");
    });
    modal.classList.remove("active");

    document.querySelector("html").classList.remove("modal-inicialized");
}

function selectedVariant(modal, sellingActive) {
    let exist = false;
    let id;
    let all_variants = modal.querySelectorAll(".variant-product");
    let modalAddToCart = modal.querySelector(".modal-add-to-cart");

    let price = (parseInt(sellingActive.dataset.sellingPrice) / 100).toFixed(2);
    let oldPrice = (parseInt(sellingActive.dataset.comparePrice) / 100).toFixed(2);
    let percentage = sellingActive.dataset.percentage;

    if (sellingActive.checked) {
        all_variants[0].querySelector(".variant-prices").innerHTML = `<strong>$${oldPrice}</strong> $${price}<span class="save-price">Save $${percentage}</span>`;
    } else {
        all_variants[0].querySelector(".variant-prices").innerHTML = `<span class="variant-prices">$${oldPrice}</span>`;
    }


    all_variants.forEach(function(variant) {
        variant.addEventListener("click", function() {
            all_variants.forEach(function(variant) {
                variant.classList.remove("selected");
            });

            variant.classList.add("selected");
            exist = true;
        });
    });

    modalAddToCart.addEventListener("click", function() {
        if (exist) {
            all_variants.forEach(function(variant) {
                if (variant.classList.contains("selected")) {
                    id = variant.dataset.id;
                    selling = sellingActive.checked ? variant.dataset.selling : '';
                    add_to_cart(id, selling, modal);

                }
            });
        }
    });
}

docReady(function() {

    let add_tocart2 = document.querySelectorAll(".product-modal .btn-add-to-cart-2");

    if (add_tocart2) {
        add_tocart2.forEach(function(button) {
            button.addEventListener("click", function(e) {
                let sectionModal = button.closest(".product-modal");
                let modal = sectionModal.querySelector(".window-modal");
                let selectionModal = modal.querySelector(".modal-selection");

                let sellingActive = button.parentNode.parentNode.querySelector(".form-group-check input")

                open_Modal(modal, sellingActive)

                let closeModal = modal.querySelector(".close-modal");

                closeModal.addEventListener("click", function() {
                    close_Modal(sectionModal, modal);
                });
                modal.addEventListener("click", function(e) {
                    if (selectionModal.contains(e.target)) {
                        return;
                    } else {
                        close_Modal(sectionModal, modal);
                    }
                });
                selectedVariant(modal, sellingActive);
            });
        });
    }

    let add_tocart = document.querySelectorAll(".product-modal .btn-add-to-cart");
    if (add_tocart) {
        add_tocart.forEach(function(button) {
            button.addEventListener("click", function(e) {
                let sellingActive = button.parentNode.parentNode.querySelector(".form-group-check input");

                let id = button.dataset.id;
                let selling = '';

                if (sellingActive)
                    selling = sellingActive.checked ? button.dataset.selling : '';

                add_to_cart(id, selling);
            });
        });
    }
});